import React from 'react'
import { Link } from "react-router-dom";
import './adminSign.css'


export default function AdminSign() {
  return (
    <div className="adminSignContainer">
      <div className="logInBox">
        <img src="./images/Logos/Logo.svg" alt="Logo"></img>
        <div className="loginFrame">
          <h1>Login</h1>
          <form>
            <label>Email ID</label>
            <input type="email"></input>
            <span>Email ID is incorrect</span>
            <label>Password</label>
            <input type="password"></input>
            <span>Password is incorrect</span>
          </form>
          <div className="loginButton">
            <Link to="/adminDashboard">
              <button>Sign In</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}




